module.exports = __webpack_public_path__ + "static/media/close.9f0a8944.svg";